module.exports = __webpack_public_path__ + "static/media/CurrentLocationIcon.35772b0a.png";